/**
 * Assets Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const assetsAPI = {
  getAll: (params) => apiClient.get('/assets', { params }),
  getById: (id) => apiClient.get(`/assets/${id}`),
  getStats: (params) => apiClient.get('/assets/stats/summary', { params }),
  create: (data) => apiClient.post('/assets', data),
  update: (id, data) => apiClient.put(`/assets/${id}`, data),
  delete: (id) => apiClient.delete(`/assets/${id}`),
};

export default assetsAPI;

